import { Spinner } from '@7shifts/sous-chef';
import { lazy, Suspense } from 'react';
import ErrorBoundary from 'sharedComponents/ErrorBoundary';

const ChannelsListPage = lazy(() => import('./pages/ChannelsListPage'));

export const ROUTES = [
    {
        path: '/channels',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ChannelsListPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
